import React from "react";

import CheckIcon from "@uui/Check";
import LinkIcon from "@uui/Link01";

import styled from "@mui/material/styles/styled";

import useRssLinksSettings from "@app/analytics/hooks/settings/useRssLinksSettings";

import Button from "@rui/Button";
import CopyButton from "@rui/CopyButton";
import Link from "@rui/Link";

const CopyableButton = styled(Button)(({ theme }) => ({
  height: "40px",
  "& .scheduling-link-label--hover": {
    display: "none",
  },
  "& .scheduling-link-label": {
    width: "100%",
    minWidth: "110px",
    textAlign: "left",
  },
  [theme.breakpoints.down("md")]: {
    minWidth: 0,
    padding: theme.spacing(1.5),
    "& .MuiButton-startIcon": {
      margin: 0,
    },
    "& .scheduling-link-label": {
      display: "none",
    },
  },
  [theme.breakpoints.up("md")]: {
    "&:hover": {
      "& .scheduling-link-label--default": {
        display: "none",
      },
      "& .scheduling-link-label--hover": {
        display: "inline",
      },
    },
  },
}));

const SchedulingLink = ({
  copied = false,
  onClick,
}: {
  copied?: boolean;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
}) => (
  <CopyableButton
    onClick={onClick}
    sx={{
      bgcolor: copied ? "shades.meadow.600" : undefined,
      "&:hover": {
        bgcolor: copied ? "shades.meadow.600" : undefined,
      },
    }}
    startIcon={copied ? <CheckIcon /> : <LinkIcon />}
  >
    <span className="scheduling-link-label scheduling-link-label--default">
      {copied ? "Link Copied!" : "Scheduling Link"}
    </span>
    <span className="scheduling-link-label scheduling-link-label--hover">
      {copied ? "Link Copied!" : "Copy Your Link"}
    </span>
  </CopyableButton>
);

const CopySchedulingLink = ({ onCopy }: { onCopy?: () => void }) => {
  const { rssLinkSettings, rootSchedulingLinkUrl } = useRssLinksSettings();

  if (rssLinkSettings.isEnabled) {
    return (
      <CopyButton
        copyValue={rootSchedulingLinkUrl}
        onClick={onCopy}
        renderButton={({ onClick }, copied) => (
          <SchedulingLink onClick={onClick} copied={copied} />
        )}
      />
    );
  }

  return (
    <Link href={rootSchedulingLinkUrl}>
      <SchedulingLink />
    </Link>
  );
};

export default CopySchedulingLink;
